import { Component, OnInit, ViewChild } from '@angular/core';
import { MaxPainel } from 'src/app/models/max-painel';
import { MatPaginator, MatDialog, MatDialogRef, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { MaxPainelService } from 'src/app/services/max-painel.service';
import { CadastrarMaxPainelModalComponent } from '../cadastrar-max-painel-modal/cadastrar-max-painel-modal.component';
import { PaginatorService } from 'src/app/services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-max-painel-modal',
  templateUrl: './max-painel-modal.component.html',
  styleUrls: ['./max-painel-modal.component.scss']
})
export class MaxPainelModalComponent implements OnInit {
  maxPaineisFiltrados: MaxPainel[] = [];
  carregando = true;
  campoOrdenacao = 'ateQtd';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<MaxPainelModalComponent>,
    private maxPainelService: MaxPainelService,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarMaxPaineis();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarMaxPaineis();
    this.paginator.firstPage();
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarMaxPaineis();
  }

  salvarMaxPainel(maxPainel: MaxPainel) {
    maxPainel.medidaPerfil = Number(maxPainel.medidaPerfil);

    this.carregandoService.mostra('salvarMaxPainel');

    this.maxPainelService.salvar(maxPainel).subscribe(
      () => {
        this.buscarMaxPaineis();
        this.carregandoService.esconde('salvarMaxPainel');
      },
      err => {
        this.carregandoService.esconde('salvarMaxPainel');
        this.notificacaoService.erro(err);
      }
    )
  }

  excluirMaxPainel(maxPainel: MaxPainel) {
    this.carregandoService.mostra('excluirMaxPainel');

    this.maxPainelService.excluir(maxPainel.id).subscribe(
      () => {
        this.buscarMaxPaineis();
        this.carregandoService.esconde('excluirMaxPainel');
      },
      err => {
        this.carregandoService.esconde('excluirMaxPainel');
        this.notificacaoService.erro(err);
      }
    )
  }

  buscarMaxPaineis() {
    this.carregandoService.mostra('buscarMaxPaineis');

    this.maxPainelService.consultarMaxPainelComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(
      (dados) => {
        this.maxPaineisFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregandoService.esconde('buscarMaxPaineis');
      }
      , err => {
        this.carregandoService.esconde('buscarMaxPaineis');
        this.notificacaoService.erro(err);
      }
    );
  }

  novoMaxPainel() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarMaxPainelModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.salvarMaxPainel(res);
    });
  }

  editarMaxPainel(maxPainel: MaxPainel) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarMaxPainelModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { maxPainel },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.salvarMaxPainel(res);
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}